import { SxStyleProp } from 'theme-ui';

export const BaseContainer: SxStyleProp = {
  color: '#FFF',
};

export const ContentContainer: SxStyleProp = {
  flexDirection: ['column', 'row'],
  flex: 1,
  minHeight: [null, '616px'],
};

export const QuoteImageContainer: SxStyleProp = {
  justifyContent: 'center',
  alignItems: 'flex-start',
  flex: 1,
};

export const CompanyImage: SxStyleProp = {
  maxWidth: ['180px !important', '240px !important'],
  width: '100%',
};

export const PersonImage: SxStyleProp = {
  alignSelf: 'center',
  justifySelf: 'center',
  maxWidth: ['180px !important', '240px !important'],
  width: '100%',
};

export const QuoteTextContainer: SxStyleProp = {
  flexBasis: '70%',
  padding: ['40px 20px', '20px 20px'],
  justifyContent: 'center',
  alignItems: 'flex-start',
  flexDirection: 'column',
};
export const ReviewTitle: SxStyleProp = {};

export const ReviewText: SxStyleProp = {
  marginTop: '20px',
};

export const PersonInfoContainer: SxStyleProp = {
  marginTop: '15px',
};

export const PersonInfoName: SxStyleProp = {
  fontWeight: 'bold',
};

export const PersonRatingCompanyLogoContainer: SxStyleProp = {
  alignItems: 'flex-start',
  width: 'fit-content',
  flexDirection: ['column', 'row'],
  marginTop: ['15px', '45px'],
};

export const PersonCompanyLogo: SxStyleProp = {
  marginLeft: ['auto', '24px'],
  marginTop: ['10px', null],
  marginBottom: ['20px', null],
};
